import React, { useEffect, useState } from 'react';
import _isEmpty from 'lodash/isEmpty';
import { useDispatch, useSelector } from 'react-redux';
import { List, ListItem, ListItemText } from '@material-ui/core';
import { Circle } from '@mui/icons-material';
import AddIcon from '@material-ui/icons/Add';
import SideBarListStyles from '../../styles/SideBarListStyle';
import {
  setSelectedTopic,
  setSelectedTopicInfo,
  setTopicsSidebar,
  showProgress,
} from '../../redux/actions/DealershipActions';
import Service from '../../apis/service';
import { ErrorToast } from '../utils/Utils';
import ShowProgress from '../ui/Backdrop';
import FloatButton from '../sidebar/FloatButton';
import AddTopicPopup from './AddTopicPopup';
import { apiEndpoints } from '../../constants/apiEndpoints';

export default function SidebarListTopics(props) {
  const { filterArray } = props;
  const classes = SideBarListStyles();
  const dispatch = useDispatch();
  const selectedTopic = useSelector((state) => state.topicsData.selectedTopic);

  const [isOpenAddTopicPopup, setIsOpenAddTopicPopup] = useState(false);

  const value = props.value === undefined ? 0 : props.value;

  const fetchSidebarList = async () => {
    dispatch(showProgress(true));

    try {
      const res = await Service.get(apiEndpoints.TOM_TOPICS_BY_DATES);
      dispatch(setTopicsSidebar(res));
      if (!_isEmpty(res)) {
        handleListItemClick(res[0]);
      }
    } catch (error) {
      ErrorToast(error);
    }
    dispatch(showProgress(false));
  };

  useEffect(() => {
    fetchSidebarList();
  }, []);

  const fetchSelectedTopicInfo = async () => {
    dispatch(showProgress(true));

    try {
      const res = await Service.get(apiEndpoints.TOPIC_BY_ID.replace('ID', selectedTopic.id));
      dispatch(setSelectedTopicInfo(res));
    } catch (error) {
      ErrorToast(error);
    }
    dispatch(showProgress(false));
  };

  useEffect(() => {
    if (selectedTopic?.id) {
      fetchSelectedTopicInfo();
    }
  }, [selectedTopic]);

  const myRefs = filterArray?.reduce((acc, val) => {
    acc[val.id] = React.createRef();
    return acc;
  }, {});

  useEffect(() => {
    myRefs[selectedTopic.id]?.current?.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });
  }, [selectedTopic, filterArray]);

  const handleListItemClick = async (data = {}) => {
    dispatch(showProgress(true));

    if (!_isEmpty(data)) {
      dispatch(setSelectedTopic(data));
    }
    dispatch(showProgress(false));
  };

  const getJourneyCount = (count) => {
    const suffix = count > 1 ? 'Journeys' : 'Journey';
    return `${count} ${suffix}`;
  };

  const addNewTopic = () => {
    setIsOpenAddTopicPopup(true);
  };

  const fabs = [
    {
      color: 'primary',
      className: classes.fab,
      icon: <AddIcon />,
      label: 'Add',
    },
    {
      color: 'primary',
      className: classes.fab,
      icon: <AddIcon />,
      label: 'Add',
    },
  ];
  return (
    <div className={classes.root}>
      <List component="nav" aria-label="secondary mailbox folder">
        {filterArray?.map((data) => (
          <div key={data.id} className={selectedTopic.id === data.id ? classes.highlightItem : ''}>
            <ListItem
              id={`Item${data.id}`}
              key={data.id}
              button
              selected={selectedTopic.id === data.id}
              className={classes.listStyling}
              onClick={() => handleListItemClick(data)}
              ref={myRefs[data.id]}
            >
              <ListItemText
                primary={
                  <div>
                    <p
                      className={`${
                        selectedTopic.id === data.id ? classes.listTextSelected : classes.listTextNonSelected
                      }`}
                    >
                      {data.title}
                    </p>
                    <p
                      style={{
                        fontSize: '10px',
                        marginTop: '-10px',
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        gap: '5px',
                      }}
                    >
                      ID: {data?.id}
                      <Circle style={{ fontSize: '8px', color: 'gray' }} /> {getJourneyCount(data.journeyCount)}
                      <Circle style={{ fontSize: '8px', color: 'gray' }} /> {data.departmentTitle}
                    </p>
                  </div>
                }
              />
            </ListItem>
          </div>
        ))}
      </List>
      <FloatButton fabs={fabs} value={value} mainTabID={16} onaddNewTopic={addNewTopic} />
      {isOpenAddTopicPopup && <AddTopicPopup isOpen={isOpenAddTopicPopup} setIsOpen={setIsOpenAddTopicPopup} />}
      <ShowProgress />
    </div>
  );
}
